import { useEnvironment } from '@wix/yoshi-flow-editor';
import {
  useSettings,
  useStyles,
} from '@wix/yoshi-flow-editor/tpa-settings/react';

import settingsParams from '../../../../settingsParams';
import stylesParams from '../../../../stylesParams';

const pageContainerWidth = 980;
const pageMargin = 60;

export const usePostWidth = () => {
  const styles = useStyles();
  const { dimensions } = useEnvironment();
  const cardWidth = styles.get(stylesParams.blogPostCardWidth);
  const cardMargin = styles.get(stylesParams.blogPostCardMargin);
  const cardListWidth =
    dimensions.width && dimensions.width < pageContainerWidth
      ? dimensions.width - pageMargin
      : pageContainerWidth - pageMargin;

  let columnsPerRow = Math.floor(cardListWidth / cardWidth) || 1;
  const gapCount = columnsPerRow - 1;

  if (columnsPerRow * cardWidth + cardMargin * gapCount > cardListWidth) {
    columnsPerRow--;
  }

  const cardSpacing =
    cardListWidth -
    cardWidth * columnsPerRow -
    cardMargin * (columnsPerRow - 1);

  return {
    postWidth: Math.round(cardWidth + cardSpacing || 1 / columnsPerRow || 1),
  };
};

export const usePostRenderer = () => {
  const settings = useSettings();

  return {
    showPostPublishDate: settings.get(settingsParams.showPostPublishDate),
    showPostReadingTime: settings.get(settingsParams.showPostReadingTime),
    showPostExcerpt: settings.get(settingsParams.showPostExcerpt),
    showPostViewsCounter: settings.get(settingsParams.showPostViewsCounter),
    showPostCommentsCounter: settings.get(
      settingsParams.showPostCommentsCounter,
    ),
    showPostLikesCounter: settings.get(settingsParams.showPostLikesCounter),
  };
};
